$(function(){

	console.log(timestamp + ' lexikon loaded ready ...');

	$('html.page-tmpl-lexikon-start').eq(0).each(function(){

		var animationDuration = 90,
			scrollOffset = 20;

		var sections_list = $('.lexikon-items-index-list-sections'),
			sections = $('.lexikon-items-index-list-section'),
			activeClass = 'section-open',
			sections_list_height_offset = sections_list.height();

		// selector_sections.hide();

		$('.lexikon-items-index-selector-item > a').on('click', function () {

			var new_section = $($(this).data('target')),
				new_section_height = new_section.height(),
				new_section_list_height = new_section_height + sections_list_height_offset;

			console.log(new_section);

			if (!new_section.hasClass(activeClass)) {

				sections_list.animate({height: new_section_list_height}, animationDuration);
				sections.hide().removeClass(activeClass);
				new_section.fadeIn('slow').addClass(activeClass);

			}

			var currentBreakpoint = getCurrentBreakpoint();

			if (currentBreakpoint == 'xs') {

				$(window).scrollTo('.lexikon-items-index-list-wrapper', animationDuration, { offset: 0, easing: 'easeOutCubic' });

			}

			return false;

		});

		$(window).on('resize', function () {

			var activeSection = sections.filter('.' + activeClass),
				new_section_list_height = activeSection.height() + sections_list_height_offset;

			if (sections_list.height() !== new_section_list_height) {
				sections_list.stop().animate({height: new_section_list_height}, animationDuration);
			}

		});

		$('.lexikon-items-index-list-item > a').on('click', function () {

			var target = $($(this).data('target'));

			$(window).scrollTo(target, animationDuration, { offset: -($('.shop-header-default').height() + scrollOffset), easing: 'easeOutCubic' });

		});


		// buttons "products with"
		$('.lexikon-items-item-products-with-link').hover(function(){
			var self = $(this);
			self.css('color', self.data('hover-textcolor'))
				.css('backgroundColor', self.data('hover-bgcolor'));
		}, function () {
			var self = $(this);
			self.css('color', '')
				.css('backgroundColor', '');
		});

	});

});